import app from '@/main'
import Vue from 'vue'
import i18n from '@/languages/index.js'

const autocastModule = {
  state: {
    editor_params: null,
    items: null,
    pagination: null,
    params: null,
    autocasts_plain: null
  },
  mutations: {
    setAutoCast(state, data) {
      state.items = data
    },
    setAutoCastPagination(state, data) {
      state.pagination = data
    },
    setAutoCastParams(state, data) {
      state.params = data
    },
    autocastEditorParams(state, data) {
      state.autocastEditorParams = data
    },
    setParamsAutoCast(state, data) {
      state[data.response.id] = data.response
      state[data.response.id].cases_information_autocast = {}

      if (data.message_id.length) {
        data.message_id.forEach((element) => {
          state[data.response.id].cases_information_autocast[element] = {}
        })
      }
    },
    setEditorParams(state, data) {
      state.editor_params = data
    },
    setStatisticsAutocast(state, data) {
      state[data.id].autocast_statistics_info = {
        statistics: data.statistics,
        show_test_emails: data.show_test_emails,
        time_info_start: data.time_info_start,
        time_info_end: data.time_info_end
      }
    },
    setRecipientsAutocast(state, data) {
      state[data.id].autocast_recipients = data.recipients
    },
    setParamTableInfoAutocast(state, data) {
      state[data.id].cases_information_autocast.params_table = data.param
    },
    setCasesStatisticsAutocast(state, data) {
      state[data.id].cases_information_autocast[data.message_id].message_info = {
        statistics: data.statistics,
        show_test_emails: data.show_test_emails,
        time_info_start: data.time_info_start,
        time_info_end: data.time_info_end
      }
    },
    setCasesRecipientsAutocast(state, data) {
      state[data.id].cases_information_autocast[data.message_id].message_emails = data.recipients
    },
    setCasesParamTableInfoAutocast(state, data) {
      state[data.id].cases_information_autocast[data.message_id].params_table = data.param
    },
    setDeleteAutocastById(state, data) {
      if (state[data]) {
        state.items = null
        delete state[data]
      }
    },
    setAutocastsPlain(state, autocasts_plain) {
      state.autocasts_plain = autocasts_plain
    }
  },
  getters: {
    getAutoCast: (state) => {
      return state.items
    },
    getAutoCastPagination: (state) => {
      return state.pagination
    },
    autocastEditorParams: (state) => {
      return state.autocastEditorParams
    },
    getEditorParams: (state) => {
      return state.editor_params
    },
    getAutoCastById: (state) => (id) => {
      if (state[id]) {
        return JSON.parse(JSON.stringify(state[id]))
      } else {
        return null
      }
    },
    getRecipientsAutocast: (state) => (id) => {
      return state[id].autocast_recipients
    },
    getParamTableInfoAutocast: (state) => (id) => {
      return state[id].cases_information_autocast.params_table
    },
    getCasesParamTableInfoAutocast: (state) => (data) => {
      return state[data.id].cases_information_autocast[data.message_id].params_table
    },
    getStatisticsAutocast: (state) => (id) => {
      return state[id].autocast_statistics_info
    },
    getCasesStatisticsAutocast: (state) => (params) => {
      return state[params.id].cases_information_autocast[params.message_id]
    },
    getAutocastsPlain: (state) => {
      return state.autocasts_plain
    }
  },
  actions: {
    SEND_TEST_AUTOCASTS: async ({ rootGetters }, data) => {
      try {
        const payload = Object.assign({}, data)
        const autocastId = payload.autocast_id
        delete payload.autocast_id
        const response = await Vue.http.post(
          `${rootGetters.getBackendUrl}/autocasts/autocast/${autocastId}/test_email`,
          payload,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.status === 200) {
          app.$message('success', i18n.t('instruments.auto_cust.send_test_success'))
        }
      } catch (e) {
        app.$raven.captureException(e)
        app.$message('danger', e.body.message)
      }
    }
  }
}

export default autocastModule



// WEBPACK FOOTER //
// ./src/store/modules/autocast.js